/**
 * JSON with object keys in sorted order at every level, so two values that
 * are the same JSON document serialise the same whatever order their keys
 * were built in. Postgres stores jsonb with its own key order, so a row read
 * back never stringifies like the object that was sent; comparing the two
 * through JSON.stringify would call every save a conflict.
 */
export const stableStringify = (value: unknown): string => {
  if (value === null || typeof value !== 'object') return JSON.stringify(value);
  if (Array.isArray(value)) return `[${value.map(stableStringify).join(',')}]`;
  const record = value as Record<string, unknown>;
  const keys = Object.keys(record).filter(k => record[k] !== undefined).sort();
  return `{${keys.map(k => `${JSON.stringify(k)}:${stableStringify(record[k])}`).join(',')}}`;
};
